import state from "./state"
// import filter from "../utils/filter";

const mutations = {
    //自由组合数据列表
    // success: true, errorCode: 710000, msg: "OK", 
    // data: {
    //     filtered: Array(4)
    //     flightInlandItemSearchList: Array(14)
    //     flightInlandPollingCondition: (...)
    // }
    freeFlight(state, value) {
        let flightList = [];
        let flightListNew = [];
        let filteredList = [];
        let filteredListNew = [];
        //数据刷新
        if (value.reload) {
            state.freeFlight = value;
            return;
        }
        //正常加载数据
        if (value && value.data && value.data.flightInlandItemSearchList && value.data.flightInlandItemSearchList.length) {
            flightListNew = value.data.flightInlandItemSearchList;
            let queryId = value.data.flightInlandPollingCondition.queryId;
            let directionId = value.data.flightInlandPollingCondition.directionId;

            if (state.freeFlight && state.freeFlight.data && state.freeFlight.data.flightInlandItemSearchList) {
                flightList = state.freeFlight.data.flightInlandItemSearchList;


                flightListNew.forEach((newItem, newIndex) => {
                    //把queryId和directionId倒入对应机票信息
                    flightListNew[newIndex].queryId = queryId
                    flightListNew[newIndex].directionId = directionId
                    if (flightListNew[newIndex].inlandConnectionInfoList && flightListNew[newIndex].inlandConnectionInfoList.length) {
                        flightListNew[newIndex].inlandConnectionInfoList.forEach((smItem, smIndex) => {
                            flightListNew[newIndex].inlandConnectionInfoList[smIndex].queryId = queryId;
                            flightListNew[newIndex].inlandConnectionInfoList[smIndex].directionId = directionId;
                        })
                    }


                    //查看原有数据里是否有新数据的值
                    let flag = -1
                    flightList.forEach((item, index) => {
                        if (item.flightKey === newItem.flightKey) {
                            flag = index;
                        }
                    })
                    // 如发现重复航班则替换,否则就倒入
                    if (flag === -1) {
                        flightList.push(newItem)
                    } else {
                        flightList[flag] = newItem
                    }
                })
            } else {
                //直接赋值
                state.freeFlight.data.flightInlandItemSearchList = flightListNew
            }
        }

        if (value && value.data && value.data.filtered && value.data.filtered.length) {
            filteredListNew = value.data.filtered;
            if (state.freeFlight && state.freeFlight.data && state.freeFlight.data.filtered) {
                filteredList = state.freeFlight.data.filtered

                filteredListNew.forEach((newItem, newIndex) => {
                    //查看原有数据里是否有新数据的值
                    let flag = -1;
                    filteredList.forEach((item, index) => {
                        if (item.field === newItem.field) {
                            flag = index;
                        }
                    })
                    // 相同field条件下合并子条件 不同field直接插入
                    if (flag === -1) {
                        filteredList.push(newItem)
                    } else {

                        // filteredList[flag].items = newItem.items 
                        newItem.items.forEach((objNew, i) => {

                            let smFlag = -1;
                            filteredList[flag].items.forEach((obj, j) => {
                                if (obj.code === objNew.code) {
                                    smFlag = j;

                                }
                            })
                            if (smFlag === -1) {
                                filteredList[flag].items.push(objNew)
                            }
                        })


                    }

                })

            } else {
                state.freeFlight.data.filtered = filteredListNew
            }


        }

        if (value && value.data && value.data.flightInlandPollingCondition) {
            state.freeFlight.data.flightInlandPollingCondition = value.data.flightInlandPollingCondition
        }

        // state.freeFlight = value;

    },

    saveRxjsMsg(state, value) {
        state.rxjsMsg = value
    },
    // setFlightList(state, value) {
    //     state.flightList = value
    // },
    setTabName(state, value) {
        state.tabName = value
    },
    setFilter(state, value) {
        let newObj = value ? JSON.parse(JSON.stringify(value)) : value;
        state.filter = newObj;
    },
    setCurrentIndex(state, value) {
        state.currentIndex = value
    },
    setChoseTicket(state, value) {
        state.choseTickets = value;
    },
    setFlightAllPriceInfo(state, value) {
        state.flightAllPriceInfo = value;
    },
    setSort(state, value) {

        state.sort = Object.assign({}, state.sort, value);
    },
    setLoading(state, value) {
        state.loading = value;
    },
    setErrormsg(state, value) {
        // debugger;
        state.errormsg = value;
    },
    setParameter3(state, value) {
        state.parameter3 = value;
    },
    setlistNum(state, value) {
        state.listNum = value;
    },

    setDialogVisible(state, value) {
        state.dialogVisible = value;
    },
    //是否展示小飞机加载数据进度条
    setShowProgress(state, value) {
        state.showProgress = value;
    },
    // setreloadProgress(state, value) {
    //     state.reloadProgress = value;
    // },
    //小飞机加载数据是否加载完成（轮询结束）
    setProgressSuccess(state, value) {
        state.progressSuccess = value;
    },

    setDirectionId(state, value) {
        state.directionId = value;
    },
    setTicketIndex(state, value) {
        state.ticketIndex = value;
    },
    setPriceDetailInfo(state, value){
        state.ticketIndex = value;
    }, 
    setCurrentRuleInfo(state, value){
        state.currentRuleInfo = value;
    },
    setShowRuleInfoLoading(state, value){
        state.showRuleInfoLoading = value;
    },
    setRuleInfoCache(state, value){
        state.ruleInfoCache = value;
    },

}
export default mutations